import { render, staticRenderFns } from "./MerchantCategoryComponent.vue?vue&type=template&id=a01da300&scoped=true"
import script from "./MerchantCategoryComponent.vue?vue&type=script&lang=js"
export * from "./MerchantCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./MerchantCategoryComponent.vue?vue&type=style&index=0&id=a01da300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01da300",
  null
  
)

export default component.exports